import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function getFooterNavigation(handle:string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('footerNavigation')
    .setMethod('GET')
    .setProps([{handle: handle}])
    .send();
}
